import React from "react";
import { Link } from "react-router-dom";
import { Mail, Send, Trophy } from "lucide-react";
import { CONTACT_EMAIL, LOGO_URL, BRAND } from "@/config";
import { TrustBadges } from "@/components/TrustBadges";

export const Footer = () => {
  return (
    <footer id="contact" className="relative z-10 border-t border-[#2a2a2a] mt-24 pb-36 sm:pb-24">
      <div className="px-6 md:px-12 py-16 grid md:grid-cols-2 gap-12 items-start">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src={LOGO_URL} alt={BRAND} className="h-10 w-10 object-contain" />
            <span className="font-heading font-extrabold text-2xl tracking-tight">{BRAND}</span>
          </div>
          <p className="text-[#9ca3af] max-w-sm leading-relaxed">
            Premium, one-of-one beats for artists who want to stand out. Stream, vibe, and own your sound — exclusively.
          </p>
          <Link to="/sold" data-testid="footer-sold-link"
            className="inline-flex items-center gap-2 mt-5 text-sm text-[#9ca3af] hover:text-[#e2ff31] transition-colors">
            <Trophy className="w-4 h-4" /> Browse the Sold Vault
          </Link>
        </div>

        <div className="md:justify-self-end w-full md:max-w-sm">
          <h3 className="font-heading text-2xl tracking-tight font-semibold mb-2">Get in touch</h3>
          <p className="text-[#9ca3af] mb-5">
            Custom beat request, licensing question, or collab? Send me an email and I'll get back to you.
          </p>
          <a
            data-testid="contact-email-btn"
            href={`mailto:${CONTACT_EMAIL}?subject=Beat%20Request%20%2F%20Inquiry`}
            className="inline-flex items-center gap-2 rounded-full bg-[#e2ff31] text-black hover:bg-[#c8e619] active:scale-95 transition-all font-semibold px-6 py-3"
          >
            <Send className="w-4 h-4" /> Email me
          </a>
          <div className="flex items-center gap-2 mt-4 text-sm text-[#9ca3af] font-mono">
            <Mail className="w-4 h-4" />
            <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-[#e2ff31] transition-colors" data-testid="contact-email-link">
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
      </div>
      <div className="px-6 md:px-12 pb-10"><TrustBadges /></div>
      <div className="px-6 md:px-12 py-6 border-t border-[#2a2a2a] text-sm text-[#6b7280] flex flex-wrap items-center justify-between gap-3">
        <span>© {new Date().getFullYear()} {BRAND}. All rights reserved.</span>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#e2ff31] transition-colors">Terms</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#e2ff31] transition-colors">Privacy</Link>
          <Link to="/refund-policy" data-testid="footer-refund-policy-link" className="hover:text-[#e2ff31] transition-colors">Refund Policy</Link>
          <a href={`mailto:${CONTACT_EMAIL}?subject=Order%20help`} data-testid="footer-support-link" className="hover:text-[#e2ff31] transition-colors">Support</a>
        </nav>
      </div>
    </footer>
  );
};
